/**
 * Point Repository Interface
 */
export class IPointRepository {
  async getBalance(userId) {
    throw new Error('Method must be implemented');
  }

  async earnPoints(data) {
    throw new Error('Method must be implemented');
  }

  async getTransactions(userId, params) {
    throw new Error('Method must be implemented');
  }

  async getEligibleCount(pharmacyId, params) {
    throw new Error('Method must be implemented');
  }

  async getPharmacyTransactions(pharmacyId, params) {
    throw new Error('Method must be implemented');
  }

  async getPointKpi(brn, params) {
    throw new Error('Method must be implemented');
  }

  async getPointStats(brn, params) {
    throw new Error('Method must be implemented');
  }
}
